import { AxiosError, AxiosRequestConfig, AxiosResponse, AxiosHeaders } from 'axios';
import { CapacitorHttp } from "@capacitor/core";

export const capacitorAxiosAdapter = async (config: AxiosRequestConfig): Promise<AxiosResponse> => {
    try {
        const method = config.method?.toUpperCase() || 'GET';

        // Asegura que los headers sean un objeto plano y nunca undefined
        let headers: Record<string, string> = {};
        if (config.headers) {
            if (config.headers instanceof AxiosHeaders) {
                const rawHeaders = config.headers.toJSON();
                headers = Object.fromEntries(
                    Object.entries(rawHeaders)
                        .filter(([_, v]) => v != null)
                        .map(([k, v]) => [k, String(v)])
                );
            } else {
                headers = { ...config.headers } as Record<string, string>;
            }
        }

        const options: any = {
            url: "https://testitdviewer.firstdata.com" + config.url,
            headers,
            params: config.params,
            data: config.data,
            method: method
        };

        const response = await CapacitorHttp.request(options);

        const res: AxiosResponse = {
            data: response.data,
            status: response.status,
            statusText: '', // HttpResponse does not have statusText
            headers: response.headers || {},
            config: { ...config, headers: AxiosHeaders.from(headers) }, // headers nunca será undefined
            request: options.request,
        };

        if (response.status > 299 || response.status < 200)
            throw new AxiosError(
                "",
                response.status + "",
                { ...config, headers: AxiosHeaders.from(headers) },
                options.request,
                res
            );

        return res;
    } catch (error) {
        throw error;
    }
};